/**
 * B Book LP API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Global status Dto.
 */
export interface GlobalStatus {
  enabled: boolean;
  openPnl: number;
  closedPnl: number;
  tradeCount: number;
  tradeVolume: number;
}
